const TransactionTouchableRow = ({ children, }) => children;
export default TransactionTouchableRow;
